import script from "./FirstPageLabList.vue?vue&type=script&setup=true&lang=js"
export * from "./FirstPageLabList.vue?vue&type=script&setup=true&lang=js"

import "./FirstPageLabList.vue?vue&type=style&index=0&id=5461f9a2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5461f9a2"]])

export default __exports__